/**
 * Documentos brasileiros — API pública reutilizável em projetos Angular/Ionic.
 *
 * Uso:
 *   import { validateCpfCnpj, patternCpfCnpjMask, cpfCnpjValidator, formatCpfCnpj } from '@app/util/brazilian-documents';
 */

export type { BrazilianDocumentKind } from './types';
export { CPF_LENGTH, CNPJ_LENGTH, CNPJ_BASE_LENGTH } from './types';

export {
  detectBrazilianDocumentKind,
  isCnpjDocument,
  isCpfDocument,
  normalizeBrazilianDocument,
} from './normalize';

export { validateCpf } from './cpf';
export { validateCnpj, cnpjCharValue, cnpjWeights } from './cnpj';

export {
  validateCpfCnpj,
  formatCpf,
  formatCnpj,
  formatCpfCnpj,
} from './cpf-cnpj';

export { patternCpfMask, patternCnpjMask, patternCpfCnpjMask } from './cpf-cnpj.mask';
export { cpfValidator, cpfCnpjValidator } from './cpf-cnpj.validator';
